module.exports = __webpack_public_path__ + "img/9788937832215.22a6de64.jpg";